module.exports = __webpack_public_path__ + "static/media/dai.83a47ff9.svg";